
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnection1Bar as ObiConnection1BarElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-1-bar.js';
 
 
 

 
 export const ObiConnection1Bar = createComponent({
   react: React,
   tagName: 'obi-connection-1-bar',
   elementClass: ObiConnection1BarElement,
   events: {
     
   }
  });
 
 